<template>
    <div class="charge_page max-content">
        <div class="charge_info">
            <p style="color:#901D22">购买费用信息：</p>
            <p>1.本次书籍购买费用为60元； </p>
            <p>2.支付完订单号，务必截图支付记录，上传后台，以便与专员核对，谢谢配合。</p>

        </div>
        <div class="ways" v-if="info">
            <h4 v-if="!show_ways && info.reg_status" style="color: #901D22;">{{ info.status == 1 ?
                '支付成功，上传截图成功，感谢您对本次书籍购买的支持，谢谢' : '信息已提交，请等待审核' }}</h4>
            <h4 v-if="info.is_end" style="color: #901D22;">活动已结束</h4>
            <h4 v-if="show_ways">请选择<span>购买内容</span></h4>
            <div v-if="show_ways" class="ways_list">
                <div @click="goRegister(1)">
                    <img src="@/assets/images/Meeting/charge_xianshang.png" alt="">
                    <span>书籍购买</span>
                </div>

            </div>
        </div>

        <div class="charge_info">
            <p style="color:#901D22">温馨提示：</p>
            <p>1.购买完书籍请如实填写信息，以便我们后期联系，寄送书籍；</p>
            <p>2.购买如出现任何问题，请联系我们工作人员： 杨艺超 18260242086。</p>
        </div>


        <div class="again" v-if="info && info.status && !info.is_end && !show_ways" @click="againClick">再填一个</div>
        <div class="again" v-if="info && !info.status && !info.is_end && !show_ways" @click="fixInfo">修改信息</div>

    </div>

</template>

<script>
import { MeetingRegInfo } from '../../../config/interface.js'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            info: null,
            show_ways: true,
            isNew: 0,
            pdf_url: 'http://www.sibcs.com/upload/sibcs2024.pdf',
            info_490: {
                meeting_id: 490,
                title1: '购买费用信息：',

            },
            showRefund: true,
            showInvoice: true,
        }
    },
    computed: {
        meeting_id() {
            return this.$route.query.meeting_id ? this.$route.query.meeting_id : (this.$route.query.id ? this.$route.query.id : this.$route.query.MT_id);
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        goRegister(val) {

            // common.confirm('提示', '注册方式一旦选择无法修改，是否确认下一步？', () => {
            if (this.info) { //	1线上2线下
                this.$router.push({
                    path: "/vascularNews/book/collectInfo2",
                    query: { type: val, step: this.info.step, meeting_id: this.meeting_id, isNew: this.isNew, t: Date.now() }
                });
            }
            // })


        },
        getDetail() {
            const url = MeetingRegInfo;
            let params = {
                meeting_id: this.meeting_id,
            }
            const method = "get";
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.info = res.data

                        if (this.info.step <= 3 && this.info.step > 1 && !this.info.is_end) {
                            // this.$router.replace({
                            //     path: "/vascularNews/book/collectInfo2",
                            //     query: { type: res.data.type_id, step: res.data.step, meeting_id: this.meeting_id,t: Date.now() }
                            // });
                            return;
                        }
                        if (res.data.status == 1 || (res.data.status == 0 && res.data.reg_status == 1) || this.info.is_end) {
                            this.show_ways = false;
                            return;
                        }


                    }
                })
        },
        fixInfo() {
            this.$router.push({
                path: "/vascularNews/book/collectInfo2",
                query: { type: this.info.type_id, step: this.info.step, meeting_id: this.meeting_id, t: Date.now() }
            });
        },
        againClick() {
            this.show_ways = true;
            this.info.step = 1;
            this.isNew = 1

        },
        downPdf() {
            window.open(this.pdf_url)
            // var u = navigator.userAgent, app = navigator.appVersion;
            // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            // var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            // if (isAndroid) {
            //     window.location.href = this.pdf_url;
            // }else
            // if (isIOS) {
            //     Dialog.alert({
            //         message: 'IOS系统用户如需下载请点击页面右上角“···”跳转到浏览器进行下载',
            //     }).then(() => {
            //         window.location.href = this.pdf_url;
            //     });
            // }

        },
    }
}
</script>

<style lang="scss" scoped>
.charge_page {
    width: 100%;
    padding: 15px;

    .charge_info {
        color: #666;
        font-size: 13px;
        font-family: PingFang SC;
        line-height: 22px;
        margin-bottom: 20px;

    }

    .ways {
        h4 {
            display: flex;
            font-size: 18px;
            margin-bottom: 10px;

            span {
                display: block;
                height: 20px;
                border-bottom: 5px solid #FFBFBF;
            }
        }

        .ways_list {
            display: flex;
            justify-content: space-between;
            align-content: center;
            margin-top: 20px;
            margin-bottom: 30px;

            >div {
                width: 165px;
                height: 72px;
                background: #FFF3F3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                border-radius: 5px;

                img {
                    width: 22px;
                    height: 22px;
                    margin-right: 20px;

                }

            }
        }
    }

}

.again {
    width: 165px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #fff;
    margin: 30px auto 0;
    border-radius: 5px;
    background: #901D22;
    font-size: 16px;
    position: fixed;
    bottom: 40px;
    left: 0;
    right: 0;

}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/book/index2.vue